import type { Static } from 'runtypes';
import { Array, Literal, Record, String } from 'runtypes';
import { CoreEventRuntype } from './core';
import type { BaseEvent } from './base';
import { BaseEventRuntype } from './base';
import { ClickstreamEventEnum } from 'bc-model';

const MenuItemClickedEventBrowserRuntype = BaseEventRuntype.And(
  Record({
    event: Literal(ClickstreamEventEnum.MENU_ITEM_CLICKED),
    path: Array(String),
    url: String,
    version: Literal(1),
  })
);

const MenuItemClickedEventServerRuntype = MenuItemClickedEventBrowserRuntype.And(
  CoreEventRuntype
).And(
  Record({
    sessionId: String,
  })
);

type MenuItemClickedBrowserEvent = Static<typeof MenuItemClickedEventBrowserRuntype>;
type MenuItemClickedServerEvent = Static<typeof MenuItemClickedEventServerRuntype>;

const isMenuItemClickedServerEvent = (obj: BaseEvent): obj is MenuItemClickedServerEvent => {
  return obj.event === 'Menu Item Clicked';
};

export type { MenuItemClickedBrowserEvent, MenuItemClickedServerEvent };
export {
  MenuItemClickedEventBrowserRuntype,
  MenuItemClickedEventServerRuntype,
  isMenuItemClickedServerEvent,
};
